(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canvas-abh"] && !Shopify.designMode) return;
  try {
    
(function(){
 const root=document.getElementById('abh-canvas-tool');if(!root)return;
 const input=root.querySelector('#abh-upload'),status=root.querySelector('#abh-status'),button=root.querySelector('#abh-download'),drop=root.querySelector('#abh-drop'),results=root.querySelector('#abh-results');
 const canvas=document.createElement('canvas');canvas.width=canvas.height=3072;const ctx=canvas.getContext('2d');let busy=false,items=[];
 const encode=q=>new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(new Error('JPG export failed')),'image/jpeg',q));
 async function compress(){let lo=0,hi=.95,best=await encode(0);if(best.size>150000)throw new Error("Cannot compress this detailed image below 150 KB at 3072 × 3072.");for(let n=0;n<8;n++){const q=(lo+hi)/2,b=await encode(q);if(b.size<=150000){best=b;lo=q;}else hi=q;}return minimumSize(best);}
 function minimumSize(blob){if(blob.size>=100000)return blob;const parts=[blob.slice(0,2)];let remaining=100000-blob.size;while(remaining>0){const length=Math.min(65537,Math.max(4,remaining)),segment=new Uint8Array(length);segment[0]=255;segment[1]=254;segment[2]=(length-2)>>8;segment[3]=(length-2)&255;parts.push(segment);remaining-=length;}parts.push(blob.slice(2));return new Blob(parts,{type:'image/jpeg'});}
 function save(blob,name){const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=name;a.click();setTimeout(()=>URL.revokeObjectURL(url),30000);}
 function message(text){const p=document.createElement('p');p.className='abh-error';p.textContent=text;results.append(p);}
 async function load(files){if(busy)return;files=Array.from(files);if(!files.length)return;if(files.length>50){status.textContent='Please choose up to 50 images per batch.';return;}busy=true;input.disabled=true;button.disabled=true;items.forEach(i=>URL.revokeObjectURL(i.url));items=[];results.replaceChildren();let failures=0,large=0;
 for(let i=0;i<files.length;i++){const file=files[i];status.textContent='Preparing '+(i+1)+' of '+files.length+'…';let url;
 try{if(!['image/jpeg','image/png','image/webp'].includes(file.type))throw new Error('Choose JPG, PNG or WebP.');if(file.size>25*1024*1024)throw new Error('Image exceeds 25 MB.');url=URL.createObjectURL(file);const img=new Image();img.src=url;await img.decode();const height=img.naturalHeight*3072/img.naturalWidth;ctx.fillStyle='#fff';ctx.fillRect(0,0,3072,3072);ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';ctx.drawImage(img,0,(3072-height)/2,3072,height);const blob=await compress();const name=String(i+1).padStart(2,'0')+'-'+(file.name.replace(/\.[^.]+$/,'').replace(/[^a-zA-Z0-9_-]/g,'-').slice(0,90)||'image')+'-3072x3072.jpg';const item={blob,name,url:URL.createObjectURL(blob)};items.push(item);if(blob.size>150000)large++;
 const card=document.createElement('article');card.className='abh-result';const preview=document.createElement('img');preview.src=item.url;preview.alt=file.name+' on white canvas';preview.width=3072;preview.height=3072;preview.loading='lazy';const title=document.createElement('h2');title.textContent=file.name;const info=document.createElement('p');info.textContent='3072 × 3072 · JPG · '+(blob.size/1000).toFixed(1)+' KB'+(height>3072?' · Center crop':'');const link=document.createElement('a');link.href=item.url;link.download=name;link.textContent='Download JPG';card.append(preview,title,info,link);if(blob.size>150000){const note=document.createElement('p');note.className='abh-error';note.textContent='Detailed image: smallest JPG at this resolution is above 150 KB.';card.append(note);}results.append(card);
 }catch(e){failures++;message(file.name+': '+(e.message||'Could not process image.'));}finally{if(url)URL.revokeObjectURL(url);}}
 busy=false;input.disabled=false;input.value='';button.disabled=!items.length;status.textContent=items.length+' JPG'+(items.length===1?'':'s')+' ready'+(failures?' · '+failures+' failed':'')+(large?' · '+large+' above 150 KB':'')+'.';}
 function crc32(bytes){let crc=0xffffffff;for(const byte of bytes){crc^=byte;for(let k=0;k<8;k++)crc=(crc>>>1)^((crc&1)?0xedb88320:0);}return (crc^0xffffffff)>>>0;}
 async function zip(entries){const parts=[],directory=[];let offset=0,dirSize=0;for(const item of entries){const data=new Uint8Array(await item.blob.arrayBuffer()),name=new TextEncoder().encode(item.name),crc=crc32(data),header=new Uint8Array(30+name.length),h=new DataView(header.buffer);h.setUint32(0,0x04034b50,true);h.setUint16(4,20,true);h.setUint16(12,33,true);h.setUint32(14,crc,true);h.setUint32(18,data.length,true);h.setUint32(22,data.length,true);h.setUint16(26,name.length,true);header.set(name,30);parts.push(header,data);const central=new Uint8Array(46+name.length),c=new DataView(central.buffer);c.setUint32(0,0x02014b50,true);c.setUint16(4,20,true);c.setUint16(6,20,true);c.setUint16(14,33,true);c.setUint32(16,crc,true);c.setUint32(20,data.length,true);c.setUint32(24,data.length,true);c.setUint16(28,name.length,true);c.setUint32(42,offset,true);central.set(name,46);directory.push(central);dirSize+=central.length;offset+=header.length+data.length;}const end=new Uint8Array(22),e=new DataView(end.buffer);e.setUint32(0,0x06054b50,true);e.setUint16(8,entries.length,true);e.setUint16(10,entries.length,true);e.setUint32(12,dirSize,true);e.setUint32(16,offset,true);return new Blob([...parts,...directory,end],{type:'application/zip'});}
 input.addEventListener('change',()=>load(input.files));['dragenter','dragover'].forEach(type=>drop.addEventListener(type,e=>{e.preventDefault();if(!busy)drop.classList.add('is-dragging');}));['dragleave','drop'].forEach(type=>drop.addEventListener(type,e=>{e.preventDefault();drop.classList.remove('is-dragging');}));drop.addEventListener('drop',e=>load(e.dataTransfer.files));
 button.addEventListener('click',async()=>{if(busy||!items.length)return;busy=true;input.disabled=true;button.disabled=true;try{status.textContent='Creating ZIP…';save(await zip(items),'canvas-abh-jpgs.zip');status.textContent=items.length+' JPGs included in ZIP.';}catch(e){status.textContent='ZIP failed. You can download each JPG separately.';}finally{busy=false;input.disabled=false;button.disabled=false;}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-smooth"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAccordion() {
    const faqButtons = document.querySelectorAll(".accordion-btn");
    faqButtons.forEach(btn => {
      btn.addEventListener("click", function() {
        const content = btn.nextElementSibling;
        const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

        // Close all other items
        document.querySelectorAll(".accordion-content").forEach(c => {
          c.style.maxHeight = null;
        });
        document.querySelectorAll(".accordion-btn svg").forEach(svg => {
          svg.classList.remove("rotate-180");
        });

        // Toggle clicked item
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          btn.querySelector("svg").classList.add("rotate-180");
        }
      });
    });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initAccordion, 100);
  } else {
    document.addEventListener("DOMContentLoaded", initAccordion);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-all-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const slides = document.querySelector('.explore-all-slides');
  const prevBtn = document.querySelector('#explore-all-prev-btn');
  const nextBtn = document.querySelector('#explore-all-next-btn');
  const totalSlides = slides.children.length;
  let currentIndex = 0;

  // Calculate slides per view
  function slidesPerView() {
    const width = window.innerWidth;
    if (width >= 1024) return 3;
    if (width >= 768) return 2;
    return 1;
  }

  // Core update function
  function updateCarousel() {
    const spv = slidesPerView();
    const maxIndex = totalSlides - spv;
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

    const translatePercent = -(currentIndex * (100 / spv));
    slides.style.transition = 'transform 0.4s ease';
    slides.style.transform = `translateX(${translatePercent}%)`;

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === maxIndex;
  }

  // Navigation buttons
  prevBtn.addEventListener('click', () => {
    currentIndex--;
    updateCarousel();
  });

  nextBtn.addEventListener('click', () => {
    currentIndex++;
    updateCarousel();
  });

  // --- Swipe Support (Simplified version that just works) ---
  let startX = 0;
  let endX = 0;
  let isTouching = false;

  slides.addEventListener('touchstart', (e) => {
    if (window.innerWidth >= 1024) return; // only mobile/tablet
    isTouching = true;
    startX = e.touches[0].clientX;
    slides.style.transition = 'none'; // disable transition while dragging
  });

  slides.addEventListener('touchmove', (e) => {
    if (!isTouching) return;
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    const spv = slidesPerView();
    const movePercent = (deltaX / slides.clientWidth) * 100;
    const baseTranslate = -(currentIndex * (100 / spv));
    slides.style.transform = `translateX(${baseTranslate + movePercent}%)`;
  });

  slides.addEventListener('touchend', (e) => {
    if (!isTouching) return;
    isTouching = false;
    endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    const spv = slidesPerView();
    const threshold = slides.clientWidth * 0.1; // 10% swipe threshold

    // Swipe left
    if (diff > threshold && currentIndex < totalSlides - spv) {
      currentIndex++;
    }
    // Swipe right
    else if (diff < -threshold && currentIndex > 0) {
      currentIndex--;
    }

    updateCarousel();
  });

  // --- Resize handling ---
  window.addEventListener('resize', () => {
    updateCarousel();
  });

  // --- Init ---
  updateCarousel();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstone-design-details"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(){
  if(!document.querySelector('.theme-template-suffix-new-gems-pdp'))return;
  const track=document.querySelector('#track');if(!track||track.dataset.lightboxReady)return;track.dataset.lightboxReady='true';
  const media=Array.from(track.querySelectorAll(':scope > .slide > img, :scope > .slide > video'));if(!media.length)return;
  const dialog=document.createElement('dialog');dialog.className='as-media-dialog';dialog.setAttribute('aria-label','Product media viewer');dialog.innerHTML='<header><p class="as-media-count" aria-live="polite"></p><button type="button" aria-label="Close media viewer">×</button></header><div class="as-media-stage"><button class="as-media-back" type="button" aria-label="Previous media">‹</button><div class="as-media-content"></div><button class="as-media-forward" type="button" aria-label="Next media">›</button></div>';document.body.append(dialog);
  const content=dialog.querySelector('.as-media-content'),count=dialog.querySelector('.as-media-count');let current=0,opener=null,oldOverflow='';
  function stop(){content.querySelectorAll('video').forEach(v=>v.pause());content.replaceChildren();}
  function show(i){stop();current=(i+media.length)%media.length;const source=media[current];let large;if(source.tagName==='VIDEO'){large=source.cloneNode(true);large.removeAttribute('id');large.removeAttribute('autoplay');large.autoplay=false;large.controls=true;large.playsInline=true;large.preload='metadata';large.style.cssText='';large.setAttribute('aria-label','Product video');}else{large=document.createElement('img');large.src=source.currentSrc||source.src;large.alt=source.alt;}content.append(large);count.textContent=(source.tagName==='VIDEO'?'Video ':'Image ')+(current+1)+' of '+media.length;}
  function open(i,trigger){opener=trigger;track.querySelectorAll('video').forEach(v=>v.pause());show(i);oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();dialog.querySelector('header button').focus();}
  dialog.querySelector('header button').addEventListener('click',()=>dialog.close());dialog.querySelector('.as-media-back').addEventListener('click',()=>show(current-1));dialog.querySelector('.as-media-forward').addEventListener('click',()=>show(current+1));
  dialog.addEventListener('keydown',e=>{if(e.target.tagName==='VIDEO')return;if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}});dialog.addEventListener('close',()=>{stop();document.body.style.overflow=oldOverflow;opener?.focus({preventScroll:true});});dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  let startX=0,startY=0;track.addEventListener('pointerdown',e=>{startX=e.clientX;startY=e.clientY;});media.forEach((item,i)=>{if(item.tagName==='VIDEO'){const button=document.createElement('button');button.type='button';button.className='as-video-enlarge';button.textContent='⛶ Expand video';button.addEventListener('mousedown',e=>e.stopPropagation());button.addEventListener('touchstart',e=>e.stopPropagation(),{passive:true});button.addEventListener('click',e=>{e.stopPropagation();open(i,button);});item.parentElement.append(button);return;}item.tabIndex=0;item.setAttribute('role','button');item.setAttribute('aria-label','Enlarge '+(item.alt||'product image'));item.addEventListener('click',e=>{if(Math.abs(e.clientX-startX)>10||Math.abs(e.clientY-startY)>10)return;e.preventDefault();e.stopImmediatePropagation();open(i,item);},true);item.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open(i,item);}});});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstone-price-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-guide-calculator]').forEach((calculator) => { const total=calculator.querySelector('[data-total-price]'),carat=calculator.querySelector('[data-carat]'),ratti=calculator.querySelector('[data-ratti]'),perCarat=calculator.querySelector('[data-per-carat]'),perRatti=calculator.querySelector('[data-per-ratti]'),error=calculator.querySelector('[data-calculator-error]'),money=new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}); const update=()=>{const t=Number(total.value),c=Number(carat.value);if(!(t>=0)||!(c>0)){ratti.textContent=perCarat.textContent=perRatti.textContent='—';error.hidden=false;return}error.hidden=true;const r=c*1.09375;ratti.textContent=r.toFixed(2);perCarat.textContent=money.format(t/c);perRatti.textContent=money.format(t/r)}; total.addEventListener('input',update);carat.addEventListener('input',update);update(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gold-rate-noida"] && !Shopify.designMode) return;
  try {
    
(function(){const root=document.getElementById('as-gold-rate');if(!root)return;const status=root.querySelector('#agr-status'),button=root.querySelector('#agr-refresh'),weight=root.querySelector('#agr-weight'),purity=root.querySelector('#agr-purity'),total=root.querySelector('#agr-total');const key='as-gold-reference-v2';let quote=null,busy=false,lastFetch=0;const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',minimumFractionDigits:0,maximumFractionDigits:0}).format(n);const stamp=t=>new Intl.DateTimeFormat('en-IN',{dateStyle:'medium',timeStyle:'short',timeZone:'Asia/Kolkata'}).format(new Date(t))+' IST';
 function valid(d){return d&&d.gold&&d.gold.currency==='INR'&&d.gold.unit==='gram'&&Number.isFinite(d.gold.buy)&&d.gold.buy>0&&Number.isFinite(Date.parse(d.timestamp))&&Date.parse(d.timestamp)<=Date.now()+300000&&Date.now()-Date.parse(d.timestamp)<86400000;}
 function calculate(){const grams=Number(weight.value);total.textContent=quote&&grams>0&&grams<=100000?money(quote.gold.buy*Number(purity.value)/24*grams):'—';}
 function render(d,cached){quote=d;root.querySelectorAll('[data-rate]').forEach(el=>el.textContent=money(d.gold.buy*Number(el.dataset.rate)/24));const table=root.querySelector('#agr-table');table.replaceChildren();[1,8,10,100].forEach(g=>{const row=document.createElement('tr');[g+' g',...[24,22,18,14].map(k=>money(d.gold.buy*k/24*g))].forEach(value=>{const cell=document.createElement('td');cell.textContent=value;row.append(cell);});table.append(row);});status.textContent=(cached?'Saved provider quote · ':'Provider quote · ')+stamp(d.timestamp)+' · FX date: '+d.fxDate+(Date.now()-Date.parse(d.timestamp)>3600000?' · Delayed quote':'');calculate();}
 async function refresh(){if(busy||Date.now()-lastFetch<60000)return;busy=true;lastFetch=Date.now();button.disabled=true;const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);try{const responses=await Promise.all([fetch('https://api.gold-api.com/price/XAU',{signal:controller.signal,credentials:'omit'}),fetch('https://api.frankfurter.dev/v1/latest?base=USD&symbols=INR',{signal:controller.signal,credentials:'omit'})]);if(responses.some(r=>!r.ok))throw Error('Feed unavailable');const [spot,fx]=await Promise.all(responses.map(r=>r.json()));if(spot.currency!=='USD'||spot.symbol!=='XAU'||fx.base!=='USD'||!Number.isFinite(fx.rates?.INR)||fx.rates.INR<=0||!Number.isFinite(Date.parse(fx.date))||Date.now()-Date.parse(fx.date)>604800000)throw Error('Invalid exchange rate');const json={data:{gold:{buy:spot.price*fx.rates.INR/31.1034768,currency:'INR',unit:'gram'},timestamp:spot.updatedAt,fxDate:fx.date}};if(!valid(json.data))throw Error('Invalid or old quote');render(json.data,false);try{localStorage.setItem(key,JSON.stringify({saved:Date.now(),data:json.data}));}catch(e){}}catch(e){console.warn('Gold rate feed:',e.message);if(quote&&valid(quote)){render(quote,true);status.textContent+=' · Refresh unavailable';}else{quote=null;status.textContent='Rates temporarily unavailable. Please try again shortly.';root.querySelectorAll('[data-rate]').forEach(el=>el.textContent='—');root.querySelector('#agr-table').innerHTML='<tr><td colspan="5">Rates unavailable</td></tr>';calculate();}}finally{clearTimeout(timer);busy=false;button.disabled=false;}}
 weight.addEventListener('input',calculate);purity.addEventListener('change',calculate);button.addEventListener('click',refresh);let cache;try{cache=JSON.parse(localStorage.getItem(key));if(valid(cache?.data))render(cache.data,true);}catch(e){}if(!cache||Date.now()-cache.saved>300000||!valid(cache.data))refresh();setInterval(()=>{if(!document.hidden)refresh();},300000);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-homepage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('alpine:init', () => {
  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : html;
  }

  function renderSectionsFromResponse(response) {
    const sectionsToRender = Alpine.store('xCartHelper')?.getSectionsToRender?.() || [];

    sectionsToRender.forEach((section) => {
      (section.selector || '').split(',').forEach((selector) => {
        const cleanSelector = selector.trim();
        const sectionEl = document.querySelector(cleanSelector);
        if (!sectionEl) return;

        if (response?.sections?.[section.id]) {
          sectionEl.innerHTML = getSectionInnerHTML(response.sections[section.id], cleanSelector);
        }
      });
    });

    const bubble = document.querySelector('#cart-icon-bubble span');
    if (bubble && Alpine.store('xCartHelper')) {
      Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.textContent || '0', 10);
    }

    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  async function eurusAddToCartWithSections(variantId, qty = 1) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));

    const sections = Alpine.store('xCartHelper')?.getSectionsToRender?.().map(s => s.id) || [];
    if (sections.length) fd.append('sections', sections);
    fd.append('sections_url', window.location.pathname);

    const url = (window.Eurus && Eurus.cart_add_url) ? Eurus.cart_add_url : '/cart/add.js';

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: fd
    });

    const json = await res.json();

    if (!res.ok || json?.status == 422) {
      throw new Error(json?.description || 'Add to cart failed');
    }

    return json;
  }

  function openMiniCart() {
    try {
      if (Alpine.store('xMiniCart')?.openCart) {
        Alpine.store('xMiniCart').openCart();
      }
    } catch (e) {}
  }

  Alpine.data('asHomepageCart', () => ({
    busy: false,

    async addToCartMaxOne(btnEl) {
      const variantId = Number(btnEl.dataset.variantId);
      if (!variantId) return;
      if (btnEl.dataset.available === 'false') return;

      const txtEl = btnEl.querySelector('.pr-card-aa-btn-text');
      const oldHtml = txtEl ? txtEl.innerHTML : '';

      this.busy = true;

      try {
        const cart = await fetchCart();
        const exists = (cart.items || []).some(item => Number(item.variant_id) === variantId);

        if (exists) {
          if (txtEl) txtEl.textContent = 'Already in cart';
          openMiniCart();

          setTimeout(() => {
            if (txtEl) txtEl.innerHTML = oldHtml;
          }, 1200);
          return;
        }

        if (txtEl) txtEl.textContent = 'Adding...';

        const response = await eurusAddToCartWithSections(variantId, 1);
        renderSectionsFromResponse(response);

        if (txtEl) txtEl.textContent = 'Added ✓';
        openMiniCart();

        setTimeout(() => {
          if (txtEl) txtEl.innerHTML = oldHtml;
        }, 1200);
      } catch (e) {
        console.error('[asHomepageCart]', e);

        if (txtEl) txtEl.textContent = 'Try again';
        setTimeout(() => {
          if (txtEl) txtEl.innerHTML = oldHtml;
        }, 1200);
      } finally {
        this.busy = false;
      }
    }
  }));
});

document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.carousel');

  carousels.forEach(carousel => {
    const container = carousel.querySelector('.carouselContainer');
    const prevBtn = carousel.querySelector('.pr-card-aa-prev-button');
    const nextBtn = carousel.querySelector('.pr-card-aa-next-button');

    if (!container || !prevBtn || !nextBtn) return;

    const slides = container.children;
    let currentIndex = 0;
    let slideWidth = slides[0] ? slides[0].offsetWidth + 8 : 0;

    function updateSlideWidth() {
      const isMobile = window.innerWidth < 768;
      slideWidth = isMobile && slides[0] ? slides[0].offsetWidth + 8 : 0;
    }

    function updateCarousel() {
      const isMobile = window.innerWidth < 768;

      if (!isMobile) {
        container.style.transform = 'translate3d(0px, 0px, 0px)';
        currentIndex = 0;
        return;
      }

      const translateX = -currentIndex * slideWidth;
      container.style.transform = `translate3d(${translateX}px, 0px, 0px)`;
    }

    updateSlideWidth();
    updateCarousel();

    nextBtn.addEventListener('click', () => {
      if (window.innerWidth < 768 && currentIndex < slides.length - 1) {
        currentIndex++;
        updateCarousel();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (window.innerWidth < 768 && currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    let startX = 0;
    let endX = 0;

    container.addEventListener('touchstart', e => {
      if (window.innerWidth >= 768) return;
      startX = e.touches[0].clientX;
    });

    container.addEventListener('touchend', e => {
      if (window.innerWidth >= 768) return;
      endX = e.changedTouches[0].clientX;

      if (startX - endX > 50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (endX - startX > 50 && currentIndex > 0) {
        currentIndex--;
      }

      updateCarousel();
    });

    window.addEventListener('resize', () => {
      updateSlideWidth();
      updateCarousel();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratti-calculator"] && !Shopify.designMode) return;
  try {
    
        // script.js - Functionality for calculator
document.addEventListener('DOMContentLoaded', function() {
    const CARAT_TO_RATTI = 1.09375; // 1 carat = 1.09375 ratti
    const CARAT_TO_GRAM = 0.2; // 1 carat = 0.2 grams
    const CARAT_TO_MG = 200; // 1 carat = 200 mg

    const caratInput = document.getElementById('carat');
    const rattiInput = document.getElementById('ratti');
    const gramInput = document.getElementById('gram');
    const mgInput = document.getElementById('milligram');
    const resetBtn = document.getElementById('resetBtn');

    function updateFromCarat(carat) {
        if (carat === '') return;
        const value = parseFloat(carat) || 0;
        rattiInput.value = (value * CARAT_TO_RATTI).toFixed(4);
        gramInput.value = (value * CARAT_TO_GRAM).toFixed(4);
        mgInput.value = Math.round(value * CARAT_TO_MG);
    }

    function updateFromRatti(ratti) {
        if (ratti === '') return;
        const value = parseFloat(ratti) || 0;
        const carat = value / CARAT_TO_RATTI;
        caratInput.value = carat.toFixed(4);
        gramInput.value = (carat * CARAT_TO_GRAM).toFixed(4);
        mgInput.value = Math.round(carat * CARAT_TO_MG);
    }

    function updateFromGram(gram) {
        if (gram === '') return;
        const value = parseFloat(gram) || 0;
        const carat = value / CARAT_TO_GRAM;
        caratInput.value = carat.toFixed(4);
        rattiInput.value = (carat * CARAT_TO_RATTI).toFixed(4);
        mgInput.value = Math.round(carat * CARAT_TO_MG);
    }

    function updateFromMg(mg) {
        if (mg === '') return;
        const value = parseFloat(mg) || 0;
        const carat = value / CARAT_TO_MG;
        caratInput.value = carat.toFixed(4);
        rattiInput.value = (carat * CARAT_TO_RATTI).toFixed(4);
        gramInput.value = (carat * CARAT_TO_GRAM).toFixed(4);
    }

    caratInput.addEventListener('input', (e) => updateFromCarat(e.target.value));
    rattiInput.addEventListener('input', (e) => updateFromRatti(e.target.value));
    gramInput.addEventListener('input', (e) => updateFromGram(e.target.value));
    mgInput.addEventListener('input', (e) => updateFromMg(e.target.value));

    resetBtn.addEventListener('click', () => {
        caratInput.value = '';
        rattiInput.value = '';
        gramInput.value = '';
        mgInput.value = '';
    });
});
 

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudraksha-tab-menu"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAccordion() {
    // Select all accordion buttons
    const faqButtons = document.querySelectorAll(".accordion-btn");

    faqButtons.forEach(btn => {
      // Remove any previous click listeners to avoid duplicates
      btn.replaceWith(btn.cloneNode(true));
    });

    // Re-select after cloning
    const updatedButtons = document.querySelectorAll(".accordion-btn");

    updatedButtons.forEach(btn => {
      btn.addEventListener("click", function() {
        const content = btn.nextElementSibling;
        const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

        // Close all other accordions
        document.querySelectorAll(".accordion-content").forEach(c => {
          if (c !== content) {
            c.style.maxHeight = null;
          }
        });

        document.querySelectorAll(".accordion-btn svg").forEach(svg => {
          if (svg !== btn.querySelector("svg")) {
            svg.classList.remove("rotate-180");
          }
        });

        // Toggle current accordion
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          btn.querySelector("svg").classList.add("rotate-180");
        } else {
          content.style.maxHeight = null;
          btn.querySelector("svg").classList.remove("rotate-180");
        }
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initAccordion, 100);
  } else {
    document.addEventListener("DOMContentLoaded", initAccordion);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const bar = document.getElementById('custom-static-bar');
  const priceEl = document.getElementById('custom-static-bar-price');
  const compareEl = document.getElementById('custom-static-bar-compare');
  const addBtn = document.getElementById('custom-static-bar-add');
  const buyBtn = document.getElementById('custom-static-bar-buy');
  const loadingSpinner = document.getElementById('loading-spinner');
  const buyLoadingSpinner = document.getElementById('buy-loading-spinner');
  const toast = document.getElementById('toast');
  const productForm = document.querySelector('form[action*="/cart/add"], form[action="/cart/add"], .product-form form');
  const qtyInput = productForm ? productForm.querySelector('input[name="quantity"], input[name="qty"], .quantity input') : null;
  const variantInput = productForm ? productForm.querySelector('input[name="id"], select[name="id"], input[type="radio"][name="id"]:checked') : null;
  let lastVariantId = null;
  // Format price to Shopify's money format
  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, bar.dataset.moneyFormat || '{{amount}}');
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: '{{ cart.currency.iso_code }}' });
  }
  // Get current quantity from the input field
  function currentQty() {
    const q = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(q) || q <= 0 ? 1 : q;
  }
  // Fetch variant data via Shopify API
  async function fetchVariantJSON() {
    let id = null;
    if (variantInput) {
      if (variantInput.tagName === 'INPUT' && variantInput.type === 'radio') {
        const checkedRadio = productForm.querySelector('input[type="radio"][name="id"]:checked');
        id = checkedRadio ? checkedRadio.value : null;
      } else {
        id = variantInput.value || (variantInput.options && variantInput.options[variantInput.selectedIndex]?.value);
      }
    }
    if (!id) {
      console.warn('No variant ID selected');
      return null;
    }
    try {
      const res = await fetch(`/variants/${id}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      console.error('Failed to fetch variant:', e);
      return null;
    }
  }
  // Update the sticky bar with the latest price
  async function updateBar() {
    const variant = await fetchVariantJSON();
    const qty = currentQty();
    if (!variant || variant.id == null) {
      priceEl.textContent = 'Select Variant';
      if (compareEl) compareEl.style.display = 'none';
      addBtn.disabled = true;
      addBtn.textContent = 'Select Variant';
      buyBtn.disabled = true;
      buyBtn.textContent = 'Select Variant';
      return;
    }
    if (variant.available === false) {
      priceEl.textContent = 'Unavailable';
      if (compareEl) compareEl.style.display = 'none';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      buyBtn.disabled = true;
      buyBtn.textContent = 'Unavailable';
      return;
    }
    const total = (variant.price || 0) * qty;
    priceEl.textContent = formatMoney(total);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney((variant.compare_at_price || 0) * qty);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    addBtn.disabled = false;
    addBtn.textContent = `Add to Cart (${qty})`; // Optional: show qty
    buyBtn.disabled = false;
    buyBtn.textContent = 'Buy Now';
  }
  // Handle Add to Cart with AJAX
  async function addToCart() {
    if (!productForm) {
      console.error('Product form not found');
      return;
    }
    const formData = new FormData(productForm);
    formData.set('quantity', String(currentQty()));
    // Show loading spinner
    loadingSpinner.style.display = 'inline-block';
    addBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) {
        console.error('Add to cart failed:', data);
        throw new Error(data.message || 'Add to cart failed');
      }
      // Dispatch custom event after successful cart update
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Show Toast notification
      toast.style.display = 'block';
      setTimeout(() => {
        toast.style.display = 'none';
      }, 3000);
      // Update global cart (using Alpine.js or similar)
      updateGlobalCart();
    } catch (e) {
      console.error(e);
      addBtn.textContent = 'Try Again';
      setTimeout(() => {
        addBtn.textContent = addBtn.disabled ? 'Unavailable' : 'Add to Cart';
      }, 1500);
    } finally {
      // Hide loading spinner
      loadingSpinner.style.display = 'none';
      addBtn.disabled = false;
    }
  }
  // "Buy Now" Button: Add to Cart and redirect to checkout
  async function buyNow() {
    if (!productForm) {
      console.error('Product form not found');
      return;
    }
    const formData = new FormData(productForm);
    formData.set('quantity', String(currentQty()));
    // Show loading spinner
    buyLoadingSpinner.style.display = 'inline-block';
    buyBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) {
        console.error('Add to cart failed:', data);
        throw new Error(data.message || 'Add to cart failed');
      }
      // Optionally show toast before redirect
      toast.textContent = 'Proceeding to checkout...';
      toast.style.display = 'block';
      setTimeout(() => {
        // window.location.href = '/checkout';
        window.breeze.startCheckout();
      }, 1000);
    } catch (e) {
      console.error(e);
      buyBtn.textContent = 'Try Again';
      setTimeout(() => {
        buyBtn.textContent = buyBtn.disabled ? 'Unavailable' : 'Buy Now';
      }, 1500);
    } finally {
      // Hide loading spinner (if not redirecting)
      buyLoadingSpinner.style.display = 'none';
      buyBtn.disabled = false;
    }
  }
  // Update global cart info (can trigger events if your theme listens for cart updates)
  function updateGlobalCart() {
    // Custom code to update the cart globally (e.g., cart icon, cart drawer)
    document.dispatchEvent(new CustomEvent('cart:updated'));
    console.log('Cart updated event dispatched');
  }
  // Event listeners for the buttons
  addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addToCart();
  });
  buyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    buyNow();
  });
  // Update the sticky bar when quantity changes
  if (qtyInput) {
    qtyInput.addEventListener('change', updateBar);
    qtyInput.addEventListener('input', updateBar);
  }
  // Listen for variant changes (theme-specific event)
  document.addEventListener('variant:change', updateBar);
  // Also listen for radio changes if using radios for variants
  const variantRadios = document.querySelectorAll('input[type="radio"][name="id"]');
  variantRadios.forEach(radio => {
    radio.addEventListener('change', updateBar);
  });
  // Initial update
  updateBar();
  // Show sticky bar when scrolling 500px
  window.addEventListener('scroll', () => {
    if (window.scrollY >= 500) {
      bar.style.display = 'flex';
    } else {
      bar.style.display = 'none';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoomer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("zoomOverlay");
  const zoomedImg = document.getElementById("zoomedImage");
  const closeBtn = overlay.querySelector(".customzoomer-zoom-close");
  const leftBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-left");
  const rightBtn = overlay.querySelector(".customzoomer-zoom-nav.customzoomer-right");
  const imageContainer = overlay.querySelector(".customzoomer-zoom-image-container");
  const slides = Array.from(document.querySelectorAll("#track .slide img"));
  if (!slides.length) return;

  let currentIndex = 0;
  let isZoomed = false;
  let translateX = 0, translateY = 0;
  let startX = 0, startY = 0;
  let touchStartX = 0, touchStartY = 0;
  let touchCurrentX = 0, touchCurrentY = 0;
  let initialScale = 1;
  let lastTapTime = 0;
  let lastTapX = 0;
  let lastTapY = 0;

  function clampPan() {
    const rect = imageContainer.getBoundingClientRect();
    const scale = initialScale;
    const minX = rect.width * (1 - scale) / 2;
    const maxX = -minX;
    const minY = rect.height * (1 - scale) / 2;
    const maxY = -minY;
    translateX = Math.max(minX, Math.min(maxX, translateX));
    translateY = Math.max(minY, Math.min(maxY, translateY));
  }

  function adaptButtonColors() {
    if (zoomedImg.naturalWidth === 0 || zoomedImg.naturalHeight === 0 || !zoomedImg.complete) return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = zoomedImg.naturalWidth;
    canvas.height = zoomedImg.naturalHeight;
    ctx.drawImage(zoomedImg, 0, 0);
    const x = Math.floor(canvas.width / 2);
    const y = Math.floor(canvas.height * 0.9);
    const data = ctx.getImageData(x, y, 1, 1).data;
    const r = data[0] / 255;
    const g = data[1] / 255;
    const b = data[2] / 255;
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    const buttons = document.querySelectorAll('.customzoomer-zoom-nav, .customzoomer-zoom-close');
    if (lum > 0.5) {
      // Light background: dark button bg, white text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(0,0,0,0.8)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'rgba(255,255,255,0.3)';
      });
    } else {
      // Dark background: light button bg, black text
      buttons.forEach(btn => {
        btn.style.background = 'rgba(255,255,255,0.8)';
        btn.style.color = '#000';
        btn.style.borderColor = 'rgba(0,0,0,0.3)';
      });
    }
  }

  function openZoom(index) {
    currentIndex = index;
    zoomedImg.onload = function() {
      adaptButtonColors();
    };
    zoomedImg.src = slides[index].src;
    overlay.classList.add("active");
    resetZoom();
  }

  function closeZoom() {
    overlay.classList.remove("active");
    resetZoom();
  }

  function resetZoom() {
    isZoomed = false;
    initialScale = 1;
    translateX = translateY = 0;
    imageContainer.style.cursor = 'grab';
    zoomedImg.style.transformOrigin = 'center center';
    updateTransform();
  }

  function updateTransform() {
    zoomedImg.style.transform = `scale(${initialScale}) translate(${translateX}px, ${translateY}px)`;
  }

  function zoomAtPoint(clientX, clientY, scale) {
    const rect = imageContainer.getBoundingClientRect();
    const x = (clientX - rect.left) / rect.width;
    const y = (clientY - rect.top) / rect.height;
    zoomedImg.style.transformOrigin = `${x * 100}% ${y * 100}%`;
    initialScale = scale;
    updateTransform();
  }

  function toggleZoom(clientX, clientY) {
    const newScale = isZoomed ? 1 : 2;
    if (newScale === 1) {
      translateX = 0;
      translateY = 0;
    }
    zoomAtPoint(clientX, clientY, newScale);
    isZoomed = (newScale > 1);
    imageContainer.style.cursor = isZoomed ? 'grab' : 'default';
    if (isZoomed) clampPan();
    // Ensure button colors are adapted after zoom
    setTimeout(adaptButtonColors, 100);
  }

  let isDragging = false;

  // Double click for mouse
  zoomedImg.addEventListener("dblclick", (e) => {
    e.stopPropagation();
    toggleZoom(e.clientX, e.clientY);
  });

  // Mouse drag to pan when zoomed
  imageContainer.addEventListener("mousedown", (e) => {
    if (!isZoomed || e.button !== 0) return;
    e.preventDefault();
    isDragging = true;
    startX = e.clientX - translateX;
    startY = e.clientY - translateY;
    imageContainer.style.cursor = "grabbing";

    function onMove(ev) {
      if (!isDragging) return;
      ev.preventDefault();
      translateX = ev.clientX - startX;
      translateY = ev.clientY - startY;
      clampPan();
      updateTransform();
    }

    function onUp(ev) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    }

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  });

  // Touch handling for pan, swipe, and double tap
  imageContainer.addEventListener("touchstart", (e) => {
    if (e.touches.length > 1) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    touchCurrentY = touchStartY;
    if (isZoomed) {
      startX = touchStartX - translateX;
      startY = touchStartY - translateY;
      isDragging = true;
      imageContainer.style.cursor = "grabbing";
    }
  }, { passive: false });

  imageContainer.addEventListener("touchmove", (e) => {
    if (e.touches.length > 1) return;
    e.preventDefault();
    touchCurrentX = e.touches[0].clientX;
    touchCurrentY = e.touches[0].clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;

    if (isZoomed && isDragging) {
      translateX = touchCurrentX - startX;
      translateY = touchCurrentY - startY;
      clampPan();
      updateTransform();
    }
  }, { passive: false });

  imageContainer.addEventListener("touchend", (e) => {
    if (e.changedTouches.length !== 1) return;
    const touch = e.changedTouches[0];
    touchCurrentX = touch.clientX;
    touchCurrentY = touch.clientY;
    const dx = touchCurrentX - touchStartX;
    const dy = touchCurrentY - touchStartY;
    const now = Date.now();
    if (isDragging) {
      isDragging = false;
      imageContainer.style.cursor = "grab";
      clampPan();
      updateTransform();
      return;
    }
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      // Swipe navigation when not zoomed
      const dir = dx > 0 ? -1 : 1;
      showNext(dir);
      return;
    }
    if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
      // Potential tap
      if (now - lastTapTime < 300 &&
          Math.abs(touch.clientX - lastTapX) < 20 &&
          Math.abs(touch.clientY - lastTapY) < 20) {
        // Double tap
        toggleZoom(touch.clientX, touch.clientY);
      }
      // Update last tap
      lastTapTime = now;
      lastTapX = touch.clientX;
      lastTapY = touch.clientY;
    }
  }, { passive: false });

  function showNext(dir = 1) {
    currentIndex = (currentIndex + dir + slides.length) % slides.length;
    // Smooth transition
    zoomedImg.style.transition = 'opacity 0.3s ease';
    zoomedImg.style.opacity = '0';
    setTimeout(() => {
      zoomedImg.onload = function() {
        adaptButtonColors();
      };
      zoomedImg.src = slides[currentIndex].src;
      resetZoom();
      zoomedImg.style.opacity = '1';
      zoomedImg.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }, 150);
  }

  slides.forEach((img, i) => {
    img.addEventListener("click", () => openZoom(i));
  });

  closeBtn.addEventListener("click", closeZoom);
  leftBtn.addEventListener("click", () => showNext(-1));
  rightBtn.addEventListener("click", () => showNext(1));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeZoom();
  });

  // Prevent context menu on long press
  imageContainer.addEventListener("contextmenu", (e) => e.preventDefault());

  document.addEventListener("keydown", (e) => {
    if (!overlay.classList.contains("active")) return;
    if (e.key === "Escape") closeZoom();
    if (e.key === "ArrowRight") showNext(1);
    if (e.key === "ArrowLeft") showNext(-1);
  });
});

  } catch(e) { console.error(e); }
})();
})();
